module.exports = '3.20.2';
// Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/version.js
// module id = 987
// module chunks = 0